var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("nav", { staticClass: "navbar" }, [
      _vm.status
        ? _c("div", { staticClass: "nav-left flex" }, [
            _c("button", {
              staticClass: "btn btn-back nav-back mr-1",
              attrs: { type: "button" },
              on: {
                click: function($event) {
                  _vm.$router.push("/reports/ratings")
                }
              }
            }),
            _vm._v(" "),
            _c("h2", { staticClass: "pl-4" }, [_vm._v(_vm._s(_vm.name))]),
            _vm._v(" "),
            _vm.status
              ? _c("div", { staticClass: "pl-4" }, [
                  _vm.status === "Active"
                    ? _c("span", { class: "btn-status btn-active" }, [
                        _vm._v(_vm._s(_vm.status))
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.status === "Inactive"
                    ? _c("span", { class: "btn-status btn-pending" }, [
                        _vm._v(_vm._s(_vm.status))
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.status === "Setup Incomplete"
                    ? _c("span", { class: "btn-status btn-rejected" }, [
                        _vm._v(_vm._s(_vm.status))
                      ])
                    : _vm._e()
                ])
              : _vm._e()
          ])
        : _vm._e()
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f4632fc2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f4632fc2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/reports/ratings/CompanyRatingsHeader.vue
// module id = null
// module chunks = 